import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {SogDataLabelValueType} from "@/shared/ui/types/SogDataLabelValueType";
import SogFormField from "@/shared/ui/SogFormField.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";
import SogForm from "@/shared/ui/SogForm.vue";
import SogNumericTextBox from "@/shared/ui/SogNumericTextBox.vue";
import {useShoppingCartStore} from "@/modules/ShoppingCart/store";
import {storeToRefs} from "pinia";
import {computed} from "vue";
import {useAccountStore} from "@/stores/accountStore";
import notificationService from "@/shared/services/NotificationService";



export default /*@__PURE__*/_defineComponent({
  __name: 'PremiumComponent',
  setup(__props) {


const _shoppingCartStore = useShoppingCartStore();
const _accountStore = useAccountStore();

const {currentItem: _current, currentShoppingCart} = storeToRefs(_shoppingCartStore);

const _isBranch = computed(() => {
  return _accountStore.person && _accountStore.person.isBranch();
});

const _minPremium = computed(() => {
  return _current.value.shoppingCartItem.minGrosPrice;
  return _isBranch.value ? 0 : _current.value.shoppingCartItem.minGrosPrice;
});

const _isInvoiced = computed(() => {
  return currentShoppingCart.value.isInvoiced;
});

async function onAddItem() {
  if (
    _current.value.shoppingCartItem.minGrosPrice &&
    _current.value.shoppingCartItem.minGrosPrice >
    _current.value.shoppingCartItem.grossPrice
  ) {
    notificationService.error("Prämie ist zu niedrig.");
    return;
  }

  await _shoppingCartStore.addItem();
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogCard, null, {
    default: _withCtx(() => [
      _createVNode(SogCardTitle, null, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode("Prämie/Anzahl", -1)
        ]))]),
        _: 1
      }),
      _createVNode(SogCardContent, null, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(SogForm, null, {
            default: _withCtx(() => [
              _createTextVNode(" Anzahl: " + _toDisplayString(_unref(_current).shoppingCartItem.count), 1)
            ]),
            _: 1
          }, 512), [
            [_vShow, _unref(_current).shoppingCartItem.productPrice?.isStoreExportBlank]
          ]),
          _createVNode(SogForm, null, {
            default: _withCtx(() => [
              _createVNode(SogFormField, { width: "200px" }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(SogNumericTextBox, {
                    ref: "_eCount",
                    modelValue: _unref(_current).shoppingCartItem.count,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(_current).shoppingCartItem.count) = $event)),
                    placeholder: "Anzahl",
                    format: "n",
                    width: "150px",
                    min: 1
                  }, null, 8, ["modelValue"]), [
                    [_vShow, _unref(_current).shoppingCartItem.productPrice?.isJustInTime]
                  ])
                ]),
                _: 1
              }),
              _createVNode(SogFormField, null, {
                default: _withCtx(() => [
                  _createVNode(SogNumericTextBox, {
                    modelValue: _unref(_current).shoppingCartItem.grossPrice,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(_current).shoppingCartItem.grossPrice) = $event)),
                    placeholder: "Prämie inkl VersSt., €",
                    format: "n2",
                    min: _minPremium.value,
                    width: "150px",
                    step: 0.5
                  }, null, 8, ["modelValue", "min"])
                ]),
                _: 1
              }),
              _withDirectives(_createVNode(SogFormField, null, {
                default: _withCtx(() => [
                  _cache[3] || (_cache[3] = _createTextVNode(" Abrechnungsbetrag: ", -1)),
                  _createVNode(SogDataLabel, {
                    value: _unref(_current).shoppingCartItem.amount,
                    "value-type": _unref(SogDataLabelValueType).Money
                  }, null, 8, ["value", "value-type"])
                ]),
                _: 1
              }, 512), [
                [_vShow, _isInvoiced.value]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(SogCardActions, null, {
        default: _withCtx(() => [
          _createVNode(SogCardActionButton, {
            "mdi-icon": "mdi-cart-plus",
            onClick: onAddItem
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode(" In den Einkaufswagen ", -1)
            ]))]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})